var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_https_contact_stg_ekyc_knoxpo_com_remoteEntry_mjs_9b70a3b5__;